
import { Component, Input, Output, EventEmitter, computed, inject, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../../directives/TranslatePipe';
import { IStaticStylesConfig } from '../../../skins/_primitives/IStaticStylesConfig';
import { LookupItem } from '../../../services/LookupService';

@Component({
  selector: 'app-reactive-badge',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './reactive-badge.component.html'
})
export class ReactiveBadgeComponent {
  @Input() status: number | undefined;
  @Input() lookupData: LookupItem[] = [];
  @Input() Skin: IStaticStylesConfig | any;
  @Input() isEditMode: boolean = false;
  @Input() deleteButton: boolean = false;
  @Input() iconAdditionalDataName: string = 'truckerresponsibleicon';

  @Output() statusChange = new EventEmitter<number>();
  @Output() deleteButtonClicked = new EventEmitter<void>();

  private cdr = inject(ChangeDetectorRef);

  getStatusDisplay(status: number | undefined): string {
    if (status === undefined) {
      return '';
    }
    const foundStatus = this.lookupData.find(s => parseInt(s.key) === status);
    return foundStatus ? foundStatus.value.trim() : '';
  }

  getStatusIcon(status: number | undefined): string {
    return this.getClasses(status, this.iconAdditionalDataName);

  }

  getContainerDisplayClasses(status: number | undefined): string {
    return this.getClasses(status, 'containerdisplaystate');
  }

  getDisplayClasses(status: number | undefined): string {
    return this.getClasses(status, 'displaystate');
  }

  private getClasses(status: number | undefined, className: string): string {
    if (status === undefined) {
      return '';
    }
    const foundStatus = this.lookupData.find(s => parseInt(s.key) === status);
    if (foundStatus && foundStatus.additionalData && foundStatus.additionalData[className]) {
      const displayState: string = foundStatus.additionalData[className];
      // J-FI : le .filter(Boolean) c'est un filter truthy values => elimine les undefined, "" (string-emtpy), 0, false , ...  
      const r = displayState.split(' ').filter(Boolean).map(cls => {
        const camelCaseCls = cls.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
        return (this.Skin as any)[camelCaseCls] || cls;
      }).join(' ');
      return r;
    }
    return '';
  }

  changeStatus(): void {
    if (this.status === undefined && this.lookupData.length > 0) {
      this.status = parseInt(this.lookupData[0].key);
    }
    if (this.isEditMode && this.status !== undefined && this.lookupData.length > 0) {
      const uniqueKeys = [...new Set(this.lookupData.map(s => parseInt(s.key)))];
      const currentIndex = uniqueKeys.indexOf(this.status);
      let nextIndex = 0;
      if (currentIndex !== -1) {
        nextIndex = (currentIndex + 1) % uniqueKeys.length;
      }
      const nextStatus = uniqueKeys[nextIndex];
      this.status = nextStatus;
      this.statusChange.emit(nextStatus);
      this.cdr.markForCheck();
    }
  }

  onClick(): void {
    this.changeStatus();
  }
}
